export default class Cache {
    constructor() {
        this.pages = {};
        this.count = 0;
        this.last = "";
    }

    cacheUrl (page) {
        this.count++;
        if (page.url in this.pages == false) {
            this.pages[page.url] = page;
        }
        this.last = this.pages[page.url];
        this.displayCache();
    }

    getPage (url) {
        return this.pages[url];
    }

    displayCache () {
        console.groupCollapsed('Cache (' + this.count + ')');
        for (var key in this.pages){
            console.log(this.pages[key]);
        }
        console.groupEnd();
    }

    exists (url) {
        if (url in this.pages)
            return true
        return false
    }
}


// WEBPACK FOOTER //
// ./core/xhrController/cache.js